import React from "react"
import classnames from "classnames"
import styles from "./DealerSearch.less"
import { H5, P, InputRadio, LoadingSection } from "AtomicComponents"
import DealerDetails from "./DealerDetails"
import fetchAPI from "AtomicUtils/fetchAPI"

class DealerSearch extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dealers: props.dealers || [],
      selected: {}
    }
  }

  componentDidMount() {
    const { postcode, dealerCode, onChange = () => { } } = this.props

    if (postcode) {
      onChange({})
      this._search(postcode, null)
    }

    if (dealerCode) {
      onChange({})
      this._search(null, dealerCode)
    }
  }

  componentDidUpdate(prevProps) {
    const { postcode, dealerCode, onChange = () => { } } = this.props

    if (prevProps.postcode !== postcode || prevProps.dealerCode !== dealerCode) {
      onChange({})
      this._search(postcode, dealerCode)
    }
  }

  _onChangeHandler = (value = "") => {
    const { onChange = () => { } } = this.props

    if (!value || value === "") {
      this.setState({
        selected: {}
      })
      return
    }

    this.setState({
      selected: value
    }, () => {
      onChange(this.state.selected)
    })
  }

  _search = async (postcode, dealerCode) => {
    console.log("search for a dealer by post code / dealer code")
    const { type } = this.props
    const { loading } = this.state

    if (!loading && (postcode || dealerCode)) {

      await this.setState({
        loading: true,
        dealers: null
      }, async () => {
        const { endpoint, onChange = () => { } } = this.props

        await fetchAPI({
          method: "POST",
          url: endpoint,
          body: {
            DealerCode: dealerCode,
            DealerType: type || null,
            PostCode: dealerCode ? null : postcode
          }
        })
        .then(async (response) => {
          const json = await response.json()
          const { errorMsg, errorCode, success, data } = json

          if (!success) {
            this.setState({
              errorMessage: errorMsg,
              errorCode,
              loading: false
            })
          } else {
            this.setState({
              dealers: data,
              selected: data[0],
              loading: false
            }, () => {
              onChange(this.state.selected)
            })
          }
        })
        .catch(() => {
          this.setState({
            loading: false
          })
        })
      })
    }
  }

  render() {
    const { disabled, type } = this.props
    const { loading, dealers, selected } = this.state

    return (
      <div
        className={classnames({
          [styles.DealerSearch]: true,
          [styles.DealerSearchDisabled]: false // disabled (dynamic value)
        })}>
          {
            loading &&
            <div className={classnames({
              [styles.DealerSearchLoadingSection]: true
            })}>
              <LoadingSection visible />
            </div>
          }
          {!dealers || !dealers.length && <span></span>}
          {dealers && dealers.map(dealer => {
            const department = dealer.departments.find(department => department.name.toLowerCase() === type.toLowerCase())

            return (
              <InputRadio
                name="dealers"
                key={dealer.id}
                value={dealer}
                checked={selected.id === dealer.id}
                onChange={this._onChangeHandler}
                label={<DealerDetails dealer={dealer} department={department} />}
              />
            )
          })}
      </div>
    )
  }
}

export default DealerSearch



// WEBPACK FOOTER //
// ./src/AtomicContainers/DealerSearch/DealerSearch.jsx